import { Controller } from "@hotwired/stimulus"
import QrScanner from "qr-scanner"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  static targets = ["scanner", "overlay", "overlayName", "overlayMessage", "overlayIcon", "start", "stop", "cameraPanel"]
  static values  = { url: String }

  connect() {
    this.scanner = null
    this.paused  = false
  }

  disconnect() {
    this.scanner?.destroy()
    this.scanner = null
  }

  async start() {
    this.startTarget.classList.add("hidden")
    this.stopTarget.classList.remove("hidden")
    this.cameraPanelTarget.classList.remove("hidden")

    this.scanner = new QrScanner(
      this.scannerTarget,
      (result) => this.onScan(result.data),
      {
        preferredCamera: "environment",
        highlightScanRegion: false,
        highlightCodeOutline: true,
        calculateScanRegion: (videoWidth, videoHeight) => {
          const size = Math.min(videoWidth, videoHeight) * 0.8
          return {
            x: (videoWidth - size) / 2,
            y: (videoHeight - size) / 2,
            width: size,
            height: size,
          }
        },
        maxScansPerSecond: 15,
      }
    )

    try {
      await this.scanner.start()
    } catch (e) {
      console.error("Camera error:", e)
      this.scanner.destroy()
      this.scanner = null
      this.startTarget.classList.remove("hidden")
      this.stopTarget.classList.add("hidden")
      this.cameraPanelTarget.classList.add("hidden")
    }
  }

  stop() {
    this.scanner?.destroy()
    this.scanner = null
    this.paused  = false
    this.startTarget.classList.remove("hidden")
    this.stopTarget.classList.add("hidden")
    this.cameraPanelTarget.classList.add("hidden")
  }

  async onScan(attendeeId) {
    if (this.paused) return
    this.paused = true

    const token = document.querySelector('meta[name="csrf-token"]').content
    try {
      const resp = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
        body: JSON.stringify({ attendee_id: attendeeId })
      })
      const data = await resp.json()
      this.showOverlay(data)
    } catch (_) {
      this.showOverlay({ success: false, error: "Network error" })
    }

    setTimeout(() => { this.paused = false }, 1500)
  }

  showOverlay(data) {
    const success = data.success
    const already = data.already
    this.overlayTarget.classList.toggle("bg-emerald-500", success && !already)
    this.overlayTarget.classList.toggle("bg-orange-500", !!already)
    this.overlayTarget.classList.toggle("bg-red-500", !success && !already)
    this.overlayIconTarget.textContent    = already ? "⚠" : (success ? "✓" : "✕")
    this.overlayNameTarget.textContent    = data.name || ""
    this.overlayMessageTarget.textContent = data.already
      ? "Already checked in"
      : (success ? "Checked in!" : (data.error || "Error"))
    this.overlayTarget.classList.remove("hidden")
    setTimeout(() => this.overlayTarget.classList.add("hidden"), 1500)
  }
}
